<template>
<div class="_container">
	<div class="_insideContainer">
    <!-- Koordinatlara göre nokta atışı yapan, asla çökmeyen ücretsiz harita -->
    <iframe :src="mapUrl" width="100%" height="700" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
	</div>
</div>
</template>

<script>
import { getFirestore, doc, onSnapshot } from "firebase/firestore";
import { getApp } from "firebase/app";

export default {
	name: 'Map',
	data() {
		return {
            // Firebase'den veri gelene kadar varsayılan koordinatlar
			lat: 41.0422,
			lng: 29.0083
		}
	},
    computed: {
        mapUrl() {
            // Enlem ve boylamı Google Maps embed URL'sine yerleştiriyoruz
            return `https://maps.google.com/maps?q=${this.lat},${this.lng}&hl=tr&z=15&output=embed`;
        }
    },
    mounted() {
        try {
            const db = getFirestore(getApp());
            // Admin panelinden koordinatları anlık dinle
            onSnapshot(doc(db, "ayarlar", "anasayfa"), (docSnap) => {
                if (docSnap.exists()) {
                    const data = docSnap.data();
                    if (data.lat && data.lng) {
                        this.lat = data.lat;
                        this.lng = data.lng;
                    }
                }
            });
        } catch (error) {
            console.error("Harita konumu çekilemedi:", error);
        }
    }
}
</script>

<style scoped>
._container { display: flex; justify-content: center; width: 100%; padding: 0 5%; filter: grayscale(100%); transition: all 0.3s; background-color: white; }
._container:hover{ filter: grayscale(0%); }
._insideContainer{ width: 100%; max-width: 1900px; }
</style>